import { render } from "./TaxRulesList.vue?vue&type=template&id=bf02019a&ts=true"
import script from "./TaxRulesList.vue?vue&type=script&lang=ts"
export * from "./TaxRulesList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__